import { VenueDataFromAPI } from 'apis/restaurant-api/merchant-admin/venue/types';

import { VenueAvailabilityStatus } from './types';

export const getVenueAvailabilityStatus = (venue: VenueDataFromAPI) => {
  if (!venue.public_visible) {
    return VenueAvailabilityStatus.INACTIVE;
  }
  if (!venue.is_online) {
    return VenueAvailabilityStatus.OFFLINE;
  }
  if (!venue.is_merchant_app_alive) {
    return VenueAvailabilityStatus.IPAD_NOT_ALIVE;
  }
  if (!venue.is_open) {
    return VenueAvailabilityStatus.CLOSED;
  }
  return VenueAvailabilityStatus.AVAILABLE;
};
